export type ImageDimensions = { width: number; height: number };

export const MAX_EVENT_IMAGE_BYTES = 15 * 1024 * 1024;
const SUPPORTED_EVENT_IMAGE_TYPES = new Set([
  'image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/heic', 'image/heif',
]);

export function fitImageRect(source: ImageDimensions, frame: ImageDimensions) {
  if (source.width <= 0 || source.height <= 0 || frame.width <= 0 || frame.height <= 0) {
    throw new Error('Image and frame dimensions must be positive');
  }
  const scale = Math.min(frame.width / source.width, frame.height / source.height);
  const width = source.width * scale;
  const height = source.height * scale;
  return { width, height, x: (frame.width - width) / 2, y: (frame.height - height) / 2 };
}

export function validateEventImageAsset(asset: { type?: string; fileSize?: number }): 'unsupported-type' | 'too-large' | null {
  if (asset.type && !SUPPORTED_EVENT_IMAGE_TYPES.has(asset.type.toLowerCase())) return 'unsupported-type';
  if (typeof asset.fileSize === 'number' && asset.fileSize > MAX_EVENT_IMAGE_BYTES) return 'too-large';
  return null;
}
